// LINE連携フローのSMS確認コード入力。check_sms成功後に line_link で連携を確定。
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useModal } from 'react-hooks-use-modal';
import { TailSpin } from 'react-loading-icons';
import { toast } from 'react-toastify';
import { Post } from '../compornents/Post';
import { Analytics } from '../compornents/Analytics';

const KEY = 'yt~z7ESU6J~tLB7ppw(CLD8WddX9PNsr6DH';

export function LinePhoneAuth() {
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [err, setErr] = useState(false);
  const [Loading, openL, closeL] = useModal('root', {});

  const customerId = sessionStorage.getItem('line_phone_cid');
  useEffect(() => {
    if (!sessionStorage.getItem('line_token') || !customerId) navigate('/login');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function check() {
    openL();
    try {
    const res = await Post('login', '/auth/check_sms.php', {
      key: KEY,
      customer_id: customerId,
      sms_auth_code: code,
    });
    if (res.result === 1) {
      // SMS認証成功 → LINEを顧客に連携（要sec：直前のログインでCookieにsec保存済み）
      const lineToken = sessionStorage.getItem('line_token');
      if (lineToken) {
        const linkRes = await Post('post', '/auth/line_link.php', { line_token: lineToken });
        if (linkRes.result !== 1) {
          // 連携自体は失敗してもログインは成立しているので警告に留める
          toast.error(linkRes.error_message || 'LINE連携に失敗しました（番号認証は完了しています）');
        }
      }
      sessionStorage.removeItem('line_token');
      sessionStorage.removeItem('line_profile');
      sessionStorage.removeItem('line_phone_cid');
      sessionStorage.removeItem('line_phone_isreg');
      closeL();
      // 新規はプロフィール入力へ、既存はホームへ
      if (Number(res.is_new) === 0) navigate('/home');
      else navigate('/register/profile');
    } else {
      setErr(true);
    }
    } catch (e) {
      console.error('[LinePhoneAuth]', e);
      toast.error('エラーが発生しました。もう一度お試しください');
    } finally { closeL(); }
  }

  return (
    <div>
      <Analytics title="LINE連携・認証コード入力" />
      <div className="Register m-auto">
        <div className="App-tel">
          <div className="auth-logo">
            <img src="/img/header_logo.png" alt="LAUNDRY PACK" />
          </div>
          <div className="tel-title">認証コードの入力</div>
          <div className="App-comment">SMSで届いた6桁の認証コードを入力してください。</div>
          <div className="App-telno">
            <input
              type="tel"
              inputMode="numeric"
              maxLength={6}
              value={code}
              onChange={(e) => { setCode(e.target.value.replace(/\D/g, '')); setErr(false); }}
              placeholder="123456"
              className="form-control"
              style={{ letterSpacing: '0.4em', textAlign: 'center', fontWeight: 700 }}
            />
            {err && <div className="text-danger mt-2">認証コードが正しくありません</div>}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
            {code.length === 6
              ? <button className="button-next" onClick={check}>認証する</button>
              : <button className="button-next-g">認証する</button>}
          </div>
        </div>
      </div>
      <Loading>
        <div className="modal rounded text-center pb-4 pl-4 pr-4 m-1">
          {/* focus-trap対策: モーダル内にtabbable要素が無いと例外で白画面になる(Login.jsxと同じ対策) */}
          <button onClick={closeL} className="hide">閉じる</button>
          <div><TailSpin stroke="#000" /></div>
          <div>処理中です</div>
        </div>
      </Loading>
    </div>
  );
}

export default LinePhoneAuth;
